import { useState, useEffect, useCallback } from "react";
import { fetchMe, signOut as apiSignOut, getOAuthUrl } from "../lib/api";
export function useAuth() {
    const [user, setUser] = useState(null);
    const [status, setStatus] = useState("loading");
    const [authMessage, setAuthMessage] = useState(null);
    useEffect(() => {
        const url = new URL(window.location.href);
        const param = url.searchParams.get("auth");
        if (param === "success" || param === "error") {
            setAuthMessage(param);
            url.searchParams.delete("auth");
            window.history.replaceState({}, "", url.toString());
        }
        fetchMe()
            .then((u) => {
            setUser(u);
            setStatus(u ? "authenticated" : "unauthenticated");
        })
            .catch(() => {
            setUser(null);
            setStatus("unauthenticated");
        });
    }, []);
    useEffect(() => {
        if (!authMessage)
            return;
        const id = setTimeout(() => setAuthMessage(null), 4000);
        return () => clearTimeout(id);
    }, [authMessage]);
    const signOut = useCallback(async () => {
        try {
            await apiSignOut();
        }
        finally {
            setUser(null);
            setStatus("unauthenticated");
        }
    }, []);
    const dismissAuthMessage = useCallback(() => setAuthMessage(null), []);
    return {
        user,
        status,
        isAuthenticated: status === "authenticated",
        signInWithGitHub: () => { window.location.href = getOAuthUrl("github"); },
        signInWithGoogle: () => { window.location.href = getOAuthUrl("google"); },
        signOut,
        authMessage,
        dismissAuthMessage,
    };
}
